// extracted by mini-css-extract-plugin
export var divider = "_oz-0";
export var systemMessage = "_oz-1";
export var systemMessageWrapper = "_oz-2";